import { render, staticRenderFns } from "./EpBenefitSwitchButton.vue?vue&type=template&id=0edfd578&"
import script from "./EpBenefitSwitchButton.vue?vue&type=script&lang=js&"
export * from "./EpBenefitSwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./EpBenefitSwitchButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports